<template>
  <div class="bg">
    <div class="vux-1px-b">
      <x-input
        text-align="right"
        placeholder="请输入渔船号"
        v-model="params.shipCode"
        placeholder-align="right"
      >
        <slot slot="restricted-label">
          <div style="width: 80px">
            <span style="color: red;margin-right: 5px">*</span>渔船号
          </div>
        </slot>
      </x-input>
    </div>
    <div class="vux-1px-b">
      <x-input
        text-align="right"
        placeholder="请输入船主姓名"
        v-model="params.shipowner"
        placeholder-align="right"
      >
        <slot slot="restricted-label">
          <div style="width: 80px">
            <span style="color: red;margin-right: 5px">*</span>船主姓名
          </div>
        </slot>
      </x-input>
    </div>
    <div class="vux-1px-b">
      <x-input
        title="说明"
        text-align="right"
        placeholder="请输入"
        v-model="params.remark"
        placeholder-align="right"
      ></x-input>
      <!--<x-textarea title="备注" v-model="params.remark" placeholder="请输入备注"> </x-textarea>-->
    </div>
    <div class="imgBox">
      <div>船舶产权证</div>
      <upload-file :params="{ path: '/addShip' }" v-model="params.shipDocument">
      </upload-file>
      <!--<img :src="params.shipDocument" />-->
    </div>
    <div class="save" v-if="loadingImg === true">
      <img class="loadingImg" src="../../assets/loading.gif" />
    </div>
    <div class="save" v-else @click="save">保存</div>
  </div>
</template>

<script>
import { createShip } from "../../api/ship";
import UploadFile from "@/components/Upload/UploaderFile";

export default {
  name: "addShip",
  components: {
    UploadFile
  },
  data() {
    return {
      loadingImg: false,
      params: {
        companyId: "",
        shipCode: "",
        shipowner: "",
        remark: "",
        shipDocument: [],
        serialNo: new Date().getTime()
      }
    };
  },
  created() {
    if (this.$route.query.companyId) {
      this.params.companyId = this.$route.query.companyId;
    }
  },
  methods: {
    save() {
      if (this.params.shipCode == "") {
        this.$showError("请输入渔船号");
      } else if (this.params.shipowner == "") {
        this.$showError("请输入船主姓名");
      } else if (this.params.shipDocument.length == 0) {
        this.$showError("请上传船舶产权证");
      } else {
        createShip(this.params)
          .then(() => {
            if (this.$route.query.companyId) {
              this.$router.go(-1);
            } else {
              this.$router.replace("/ship/shipList");
            }
          })
          .catch(err => {
            this.$showError(err);
          });
      }
    }
  }
};
</script>

<style scoped>
.bg {
  background: #fff;
  overflow: hidden;
  font-size: 14px;
}
.save {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 1;
  width: 100%;
  height: 88px;
  line-height: 88px;
  text-align: center;
  font-size: 14px;
  color: #fff;
  background: #039df8;
}
.loadingImg {
  width: 32px;
  height: 32px;
  line-height: 86px;
}
.imgBox {
  padding: 20px 30px;
}
.imgBox img {
  margin-top: 20px;
  width: 300px;
  height: 200px;
  display: block;
  overflow: hidden;
}
</style>
